import type { AudioManifest } from './types';

/** Bundled music. Looped scenes and one-shot results share one semantic catalogue. */
export const AUDIO_MANIFEST: AudioManifest = {
  sfx: {},
  music: {
    lobby: { src: '/audio/music/lobby.ogg', loop: true },
    match: { src: '/audio/music/match.ogg', loop: true },
    battle: { src: '/audio/music/battle.ogg', loop: true },
    victory: { src: '/audio/music/victory.ogg', loop: false },
    defeat: { src: '/audio/music/defeat.ogg', loop: false },
  },
};
